import request from '@/utils/request'


// 查询优惠券用户关联列表
export function listCouponUser(query) {
  return request({
    url: '/biz/admin/activity/coupon/user/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询优惠券用户关联分页
export function pageCouponUser(query) {
  return request({
    url: '/biz/admin/activity/coupon/user/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询优惠券用户关联详细
export function getCouponUser(data) {
  return request({
    url: '/biz/admin/activity/coupon/user/detail',
    method: 'get',
    params: data
  })
}

// 新增优惠券用户关联
export function addCouponUser(data) {
  return request({
    url: '/biz/admin/activity/coupon/user/add',
    method: 'post',
    data: data
  })
}

// 修改优惠券用户关联
export function updateCouponUser(data) {
  return request({
    url: '/biz/admin/activity/coupon/user/edit',
    method: 'post',
    data: data
  })
}

// 删除优惠券用户关联
export function delCouponUser(data) {
  return request({
    url: '/biz/admin/activity/coupon/user/delete',
    method: 'post',
    data: data
  })
}
